export default __webpack_public_path__ + "static/media/banner.b80915a5.jpeg";